import * as React from 'react';
import { Numberbox } from 'ui';
import { ScreenField, ScreenFieldProps } from 'app/area/codetable/item/screen-renderer/types';
import { ReadOnlyType } from 'app/area/codetable/item/types';

export const SeverityLevel = ({ codeItem, updateByKey, resetValidation, translation, readOnlyConfig, validation }: ScreenFieldProps) => {

  const onChange = (value: number) => {
    resetValidation(ScreenField.severityLevel);
    updateByKey(ScreenField.severityLevel, value);
  };

  const severityLevelValidation = !!validation && !!validation[ScreenField.severityLevel]
    ? validation[ScreenField.severityLevel] : undefined;

  const readOnly = readOnlyConfig?.[ReadOnlyType.all];

  return <div className="col-lg-6 col-sm-12">
    <Numberbox
      componentId="code_severity_level"
      readOnly={readOnly}
      label={translation ? { text: translation.severity_level, required: !readOnly } : undefined}
      value={codeItem && codeItem.level}
      onChange={onChange}
      useThousand=" "
      maxValue={999999999}
      validation={severityLevelValidation}
      required={true}
      textInvalidRangeError={translation.must_be_within_range}
    />
  </div>;
};
